import { AlertTriangle } from 'lucide-react';
import { useSiteSettings } from '@/context/SiteSettingsContext';
import { useLanguage } from '@/context/LanguageContext';

/**
 * Sitewide banner that shows when the admin has paused new orders.
 * Rendered inside <Header> so it appears at the very top of every page
 * without affecting layout when the store is open.
 */
const StoreClosureBanner = () => {
  const { settings, loaded } = useSiteSettings();
  const { lang, t } = useLanguage();

  if (!loaded) return null;
  if (settings.store_open !== false) return null;

  const msg = (lang === 'ar' ? settings.store_closed_message_ar : settings.store_closed_message)
    || settings.store_closed_message
    || t('closure.default', "We're temporarily paused for new orders.");

  return (
    <div
      role="alert"
      data-testid="store-closure-banner"
      className="w-full text-white text-center text-xs sm:text-sm px-4 py-2"
      style={{ background: 'linear-gradient(90deg, #b91c1c 0%, #f97316 100%)' }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span className="font-medium">
          <span className="hidden sm:inline">{t('closure.tag', 'Store paused:')} </span>
          {msg}
        </span>
      </div>
    </div>
  );
};

export default StoreClosureBanner;
